export const USER_LOGIN_DETAILS = "userLoginDetails";
export const USER_REGISTER_DETAILS = "userRegisterDetails";
export const PROFILE_DETAILS = "profileDetails";
export const CART_ITEMS = "cartItems";
export const WISHLIST = "wishList";
export const PRODUCT_LIST = "productList";
export const CATEGORY_LIST = "categoryList";
export const ADDRESS_LIST = "addressList";
